module.exports = __webpack_public_path__ + "img/efficient.159bca2d.jpg";